import type {
  OverlayAnchorPosition,
  OverlayXAnchorPosition,
  OverlayYAnchorPosition,
} from './pcaOverlayFactory';

export const mapOverlayXAnchorPositionToCssTranslate = (x: OverlayXAnchorPosition): string => {
  switch (x) {
    case 'left':
      return '0%';
    case 'center':
      return '-50%';
    case 'right':
      return '-100%';
  }
};

export const mapOverlayYAnchorPositionToCssTranslate = (y: OverlayYAnchorPosition): string => {
  switch (y) {
    case 'top':
      return '0%';
    case 'center':
      return '-50%';
    case 'bottom':
      return '-100%';
  }
};

export const cssTransfromValueForAnchorPosition = ({ x, y }: OverlayAnchorPosition): string => {
  const xPos = mapOverlayXAnchorPositionToCssTranslate(x);
  const yPos = mapOverlayYAnchorPositionToCssTranslate(y);
  return `translateX(${xPos}) translateY(${yPos})`;
};
